import React, { useState } from 'react';
import { Menu, ChevronDown } from 'lucide-react';

// Renders a normal horizontal tab row on desktop. Below the 640px breakpoint
// (see .admin-tabs-desktop / .admin-tabs-mobile-toggle in index.css) it
// collapses into a hamburger-style dropdown instead, since a wide tab row
// just horizontal-scrolls and hides options on a phone.
export default function TabBar({ tabs, active, onChange, size = 'md' }) {
  const [open, setOpen] = useState(false);
  const activeTab = tabs.find(t => t.id === active);
  const compact = size === 'sm';

  return (
    <div style={{ position: 'relative' }}>
      <div className="admin-tabs-desktop" style={{ display: 'flex', gap: compact ? 0 : 2, overflowX: 'auto' }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => onChange(t.id)}
            style={{ padding: compact ? '7px 10px' : '11px 14px', background: 'none', color: active === t.id ? 'var(--pink)' : 'var(--text-secondary)', fontSize: compact ? 11 : 12, fontWeight: 700, border: 'none', cursor: 'pointer', borderBottom: active === t.id ? '2px solid var(--pink)' : '2px solid transparent', transition: 'all 0.15s', fontFamily: 'var(--font)', display: 'flex', alignItems: 'center', gap: compact ? 5 : 6, whiteSpace: 'nowrap', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            {t.icon} {t.label}
            {!!t.badge && (
              <span style={{ background: active === t.id ? 'var(--pink)' : 'var(--bg-elevated)', color: active === t.id ? '#fff' : 'var(--text-muted)', fontSize: 9, fontWeight: 800, borderRadius: 8, minWidth: 15, height: 15, padding: '0 4px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                {t.badge > 99 ? '99+' : t.badge}
              </span>
            )}
          </button>
        ))}
      </div>

      <button onClick={() => setOpen(o => !o)}
        className="admin-tabs-mobile-toggle"
        style={{ alignItems: 'center', gap: 8, width: '100%', padding: '11px 14px', background: 'var(--bg-elevated)', border: 'none', color: 'var(--text)', fontSize: 12, fontWeight: 700, fontFamily: 'var(--font)', cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        <Menu size={15} />
        {activeTab?.icon} {activeTab?.label}
        <ChevronDown size={14} style={{ marginLeft: 'auto', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }} />
      </button>

      {open && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 50, marginTop: 2, background: 'var(--bg-card)', border: '1.5px solid var(--border)', borderRadius: 'var(--r-md)', boxShadow: '0 8px 24px rgba(0,0,0,0.25)', overflow: 'hidden' }}>
          {tabs.map(t => (
            <button key={t.id} onClick={() => { onChange(t.id); setOpen(false); }}
              style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', textAlign: 'left', padding: '11px 14px', background: t.id === active ? 'var(--pink-glow)' : 'none', border: 'none', borderBottom: '1px solid var(--border)', color: t.id === active ? 'var(--pink)' : 'var(--text)', fontSize: 12, fontWeight: 700, fontFamily: 'var(--font)', cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
              {t.icon} {t.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
